export default class AddressLookup {
    constructor() {
        if (typeof google == "undefined") {
            return;
        }

        var input = document.getElementById("gp_address");

        if (input) {
            var options = {
                componentRestrictions: { country: "uk" }
            };

            var autocomplete = new google.maps.places.Autocomplete(
                input,
                options
            );
            // const geocoder = new google.maps.Geocoder;
        }

        var input2 = document.getElementById("address_line_1");
        var options2 = {
            componentRestrictions: { country: "uk" }
        };

        var autocomplete = new google.maps.places.Autocomplete(
            input2,
            options2
        );
        const geocoder = new google.maps.Geocoder();

        google.maps.event.addListener(
            autocomplete,
            "place_changed",
            function() {
                var place = autocomplete.getPlace();

                geocoder.geocode({ placeId: place.place_id }, function(
                    results,
                    status
                ) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        var components = {};
                        jQuery.each(results[0].address_components, function(
                            k,
                            v1
                        ) {
                            jQuery.each(v1.types, function(k2, v2) {
                                components[v2] = v1.long_name;
                            });
                        });
                        console.log(components);

                        document.getElementById("address_line_1").value =
                            (components.street_number || "") +
                            " " +
                            (components.route || "") +
                            " " +
                            (components.premise || "");
                        document.getElementById("address_line_2").value =
                            components.locality || "";
                        document.getElementById("town").value =
                            components.postal_town || "";
                        document.getElementById("postal_code").value =
                            components.postal_code;
                        document.getElementById("county").value =
                            components.administrative_area_level_2;
                    }
                });
            }
        );
    }
}
